<template>
  <side-panel-inner class="idea">
    <template slot="actions">
      <base-button @click="deleteSystem" danger v-if="editMode" iconBefore="cross">Delete</base-button>
      <base-button @click="addSystem" :primary="true" iconBefore="plus-circle">Add</base-button>
    </template>
    <h2 slot="header" class="c-panel__header-title">New System</h2>
    <loading v-if="loading"/>
    <div class="negative-margin" v-else>
      <form>
        <message type="error" v-if="showValidationMessage">
          <h3>Form Invalid</h3>
          <p>Form is invalid, please check and try again.</p>
          <ul>
            <li v-for="error in errors.items" :key="error.id">{{error.msg}}</li>
          </ul>
        </message>

        <form-field
          full-width
          required
          label="System Name"
          name="name"
          v-validate="'required'"
          data-vv-as="system name"
          :error="errors.first('name')"
          v-model="externalSystem.name"
          placeholder="Enter system name"
        ></form-field>

        <form-field
          full-width
          label="Description"
          name="description"
          data-vv-as="description"
          type="textarea"
          v-model="externalSystem.description"
          placeholder="Describe the system"
        ></form-field>

        <form-field
          full-width
          required
          label="Link"
          name="link"
          v-validate="'required'"
          data-vv-as="link"
          type="url"
          :error="errors.first('link')"
          v-model="externalSystem.link"
          placeholder="Enter Web Address here"
        ></form-field>

        <form-field
          full-width
          label="Icon"
          helper-text="Please keep images to 50 pixels wide by 50 pixels high"
        >
          <file-upload
            name="icon"
            @uploaded="onFileUploaded"
            resource="icon"
            :bypassDuplicate="true"
            :fileTypes="['png','jpg']"
          ></file-upload>
        </form-field>

        <form-field full-width required label="Display on Homepage?">
          <form-toggle v-model="externalSystem.homepage" @toggle="toggleHomepage"/>
        </form-field>
      </form>
    </div>
  </side-panel-inner>
</template>

<script>
import { mapState, mapGetters } from "vuex";
const FileUpload = () => import("@/components/FileUpload");
import UserHasPermission from "@/mixins/UserHasPermission";
import { FormToggle } from "@/components/forms";

export default {
  name: "SystemStatusAdd",

  data() {
    return {
      showValidationMessage: false,
      loading: true,
      editMode: false
    };
  },

  /**
   * TODO:
   * What we need to do is determine whether we are posting to a main comment or a reply
   * This should be similar in nature to the pages, so look at how that is done
   */
  methods: {
    onFileUploaded(file) {
      this.externalSystem.icon_id = file.id;
      console.log("file", file);
    },
    toggleHomepage($event) {
      this.externalSystem.homepage = $event;
    },
    addSystem() {
      const vm = this;
      let action = "systems/addExternal";
      let payload = this.externalSystem;

      if (this.editMode) {
        action = "systems/editExternal";
        const postSystem = (({
          name,
          description,
          link,
          homepage,
          icon_id
        }) => ({
          name,
          description,
          link,
          homepage,
          icon_id
        }))(this.externalSystem);

        payload = { id: this.externalSystem.id, external: postSystem };
      }
      this.$validator.validate().then(result => {
        if (!result) {
          vm.validationFailed = true;
        } else {
          vm.$store.dispatch(action, payload).then(() => {
            // vm.$store.dispatch("systems/listExternal");
            vm.$store.dispatch("CLOSE_PANEL");
            vm.$store.dispatch("notifications/create", {
              body: "External system has been added",
              type: "success"
            });
          });
        }
      });
    },
    deleteSystem() {
      this.$store.dispatch("createDialog", {
        confirm: () => {
          this.$store
            .dispatch("systems/deleteExternal", this.externalSystem.id)
            .then(() => {
              this.$store.dispatch("CLOSE_PANEL",'AdminExternalSystems');
            });
        }
      });
    }
  },

  computed: {
    ...mapState("systems", ["externalSystem"])
  },
  components: {
    FileUpload,
    FormToggle
  },

  mixins: [UserHasPermission],

  mounted() {
    if (this.$route.params.id) {
      this.$store
        .dispatch("systems/readExternal", this.$route.params.id)
        .then(resp => {
          this.editMode = true;
          this.loading = false;
        });
    } else {
      this.$store.dispatch("systems/resetExternal");
      this.loading = false;
    }
  }
};
</script>


<style lang="scss" scoped>
</style>
